import { useLayoutEffect, useState } from 'react';
import { AppStorage } from '../interfaces/host';
import { isProduction } from '../constants';
import { mockAppStorage } from '../mocks/appStorage-data.mock';

const initialPayload = (): AppStorage | (() => AppStorage) => {
  return !isProduction ? (mockAppStorage as any) : ({} as AppStorage);
};

export const useInfoData = () => {
  const [infoData, setInfoData] = useState<AppStorage>(initialPayload());

  const getInfoData = () => {
    const infoLocalStorage = JSON.parse(localStorage.getItem('app_storage')!);
    setInfoData(infoLocalStorage);
  };

  useLayoutEffect(() => {
    isProduction && getInfoData();
  }, []);

  return { infoData, getInfoData };
};
